import { useRef, useState } from 'react';

export type MenuState = ReturnType<typeof useMenuState>;

// Custom hook for menu state management
export default function useMenuState() {
  const [desktopMenuOpen, setDesktopMenuOpen] = useState(false);
  const [openMenuIndex, setOpenMenuIndex] = useState<number | null>(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [expandedMobileMenu, setExpandedMobileMenu] = useState<number | null>(null);
  const closeTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const cancelCloseTimer = () => {
    if (closeTimerRef.current) {
      clearTimeout(closeTimerRef.current);
      closeTimerRef.current = null;
    }
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
    setExpandedMobileMenu(null);
  };

  const closeDesktopMenu = () => {
    setDesktopMenuOpen(false);
    setOpenMenuIndex(null);
  };

  const scheduleCloseDesktopMenu = () => {
    cancelCloseTimer();
    closeTimerRef.current = setTimeout(() => {
      closeDesktopMenu();
    }, 100);
  };

  const openDesktopMenu = (index: number) => {
    cancelCloseTimer();
    setOpenMenuIndex(index);
    setDesktopMenuOpen(true);
  };

  const toggleMobileMenu = () => setMobileMenuOpen(!mobileMenuOpen);

  const toggleMobileSubmenu = (index: number) => {
    setExpandedMobileMenu(expandedMobileMenu === index ? null : index);
  };

  return {
    mobileMenuOpen,
    desktopMenuOpen,
    openMenuIndex,
    expandedMobileMenu,
    closeMobileMenu,
    closeDesktopMenu,
    openDesktopMenu,
    scheduleCloseDesktopMenu,
    cancelCloseTimer,
    toggleMobileMenu,
    toggleMobileSubmenu,
  };
}
